import React from 'react'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IMG_BASE_URL } from '../../../config/Config';

const Customer_Feedback = (product_details_list) => {
    const Product_reviews = product_details_list?.data?.product_reviews;
    const totalReviews = Product_reviews?.length;
    const totalRating = Product_reviews?.reduce((sum, r) => sum + (r.rating || 0), 0);
    const averageRating = totalReviews ? (totalRating / totalReviews).toFixed(1) : 0;
    const ratingCounts = [1, 2, 3, 4, 5].reduce((acc, star) => {
        acc[star] = Product_reviews?.filter(r => r.rating === star).length;
        return acc;
    }, {});

    const maxCount = Math.max(...Object.values(ratingCounts), 1);

    const slidesToShow = Product_reviews?.length < 3 ? Product_reviews?.length : 3;

    const settings = {
        infinite: Product_reviews?.length > 3,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: Product_reviews?.length > 3,
        autoplaySpeed: 2000,
        arrows: Product_reviews?.length > 3,
        variableWidth: false, // Normally false when you want fixed slide counts
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Product_reviews?.length < 3 ? Product_reviews?.length : 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div>

            {
                Product_reviews?.length > 0 && (
                    <div className="bg-gray-50 py-10 mt-10">
                        <div className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div>
                                <div className="single-add-more">
                                    <div className="mx-auto text-center">
                                        <h2 className="text-3xl bodonibook_font text-gray-900 mb-1">User Review</h2>
                                        <div className="border-b-2 border-b-red w-[80px] mb-10 mx-auto"></div>
                                    </div>
                                    <div className="px-2 mb-4">
                                        <div className="grid md:grid-cols-3 items-center gap-4 p-4 border rounded-md w-full">
                                            <div>
                                                {/* <!-- Rating Summary --> */}
                                                <div className="flex items-center justify-between">
                                                    {/* <!-- Stars --> */}
                                                    <div className="flex text-yellow-400">
                                                        {[...Array(5)].map((_, i) => {
                                                            const full = Math.floor(averageRating);
                                                            const isHalf = averageRating - full >= 0.5 && i === full;

                                                            return (
                                                                <span key={i} className="relative inline-block text-[22px] mr-[6px] w-[19px] h-[19px]">
                                                                    <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                                                    {i < full && (
                                                                        <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                                                    )}
                                                                    {isHalf && (
                                                                        <i
                                                                            className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                                                            style={{ width: '50%' }}
                                                                        />
                                                                    )}
                                                                </span>
                                                            );
                                                        })}
                                                    </div>
                                                    {/* <!-- Average Score --> */}
                                                    <span className="text-gray-700 font-semibold">{averageRating} out of 5</span>
                                                </div>

                                                {/* <!-- Total Reviews --> */}
                                                <div className="text-gray-500">Based on {totalReviews} reviews</div>
                                            </div>
                                            {/* <!-- Histogram --> */}
                                            <div className="flex flex-col border-l border-r border-gray-200 gap-0.5 px-6">
                                                {[5, 4, 3, 2, 1].map(star => {
                                                    const count = ratingCounts[star] || 0;
                                                    const barWidth = (count / maxCount) * 100;

                                                    return (
                                                        <div key={star} className="flex items-center gap-4">
                                                            {/* Stars */}
                                                            <div className="flex text-yellow-400">
                                                                {[1, 2, 3, 4, 5].map(i => (
                                                                    <span
                                                                        key={i}
                                                                    >
                                                                        <i className={`gicon gi-star ${i <= star ? "text-yellow-400" : "text-gray-300"} text-[14px] mr-1.5`} />
                                                                    </span>
                                                                ))}
                                                            </div>

                                                            {/* Bar */}
                                                            <div className="flex-1 h-2 bg-gray-200 rounded overflow-hidden">
                                                                <div
                                                                    className="bg-yellow-400 h-2"
                                                                    style={{ width: `${barWidth}%` }}
                                                                ></div>
                                                            </div>

                                                            {/* Count */}
                                                            <div className="text-gray-700 font-medium text-[12px]">
                                                                {count}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* <!-- Write a Review Button --> */}
                                            <div className="flex justify-center">
                                                <a href="#" className="text-white py-2.5 px-6 bg-black hover:underline text-sm border border-gray-200">Write a review</a>
                                            </div>
                                        </div>
                                    </div>

                                    <Slider {...settings}>
                                        {/* Slide 1 */}
                                        {
                                            Product_reviews?.map((Product_reviews_result) => (
                                               
                                                    <div key={Product_reviews_result.id} className="px-2">
                                                        <div className="gi-add-more-slider w-full bg-white border border-gray-200 p-6 rounded-lg">
                                                            <div className="gi-t-review-item md:flex gap-4">
                                                                <div className="basis-[50px]">
                                                                    <img
                                                                        src={`${IMG_BASE_URL}${Product_reviews_result?.user?.profile_image}`}
                                                                        alt="user"
                                                                        className="max-w-full rounded-[5px] w-20"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <h4 className="gi-t-review-name font-semibold text-sm text-900/ capitalize">
                                                                        {Product_reviews_result?.user?.name}
                                                                    </h4>
                                                                    <div className="gi-t-review-rating flex">
                                                                        {/* {[...Array(Product_reviews_result?.rating)].map((_, i) => (
                                                                            <i key={i} className="gicon gi-star text-yellow-400 text-[11px] mr-[3px]" />))} */}
                                                                        {/* <i className="gicon gi-star-o text-[#b2b2b2] text-[11px]" /> */}
                                                                        {[...Array(5)].map((_, i) => {
                                                                            const full = Math.floor(Product_reviews_result?.rating);
                                                                            const isHalf = Product_reviews_result?.rating - full >= 0.5 && i === full;

                                                                            return (
                                                                                <span key={i} className="relative inline-block text-[15px] mr-[3px] w-[14px] h-[14px]">
                                                                                    <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                                                                    {i < full && (
                                                                                        <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                                                                    )}
                                                                                    {isHalf && (
                                                                                        <i
                                                                                            className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                                                                            style={{ width: '50%' }}
                                                                                        />
                                                                                    )}
                                                                                </span>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="gi-t-review-bottom h-16">
                                                                <div className="font-medium text-[13px] text-gray-600 pt-4 capitalize line-clamp-2">{Product_reviews_result?.review}</div>
                                                                {/* <p className="text-[14px] text-[#777] mt-3">
                                                        Lorem Ipsum is simply dummy text of the printing and
                                                        typesetting industry. Lorem Ipsum has been the industry's
                                                        standard dummy text ever since the 1500s...
                                                    </p> */}

                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                            ))
                                        }
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    )
}

export default Customer_Feedback